import { find, map } from "lodash";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { useCurrentWorkspace } from "./useCurrentWorkspace";

export function useCurrentWorkspaceFocuses() {
  const currentWorkspace = useCurrentWorkspace();
  const projectFocuses = useCurrentProject().focuses;
  return map(currentWorkspace.focuses, (focus) => {
    const fullFocus = find(projectFocuses, { id: focus.id });
    return {
      offset: focus.offset,
      ...fullFocus,
    };
  });
}
